/**
 * Страница поиска для продажи (`SaleSearchPageDto` Platform): товар общего каталога и, если он есть в кассе, ключ его карточки.
 * Агент и 1С версий не знают: лишние поля не мешают, отсутствие главных — понятная ошибка, а не падение экрана (D-056).
 */
export interface OwnSearchItem {
  productId: string
  name: string
  sku: string | null
  /** Штрихкод, по которому нашли (поиск по скану); иначе `null`. */
  matchedBarcode: string | null
  inCash: boolean
  cardKey: string | null
}

export interface OwnSearchPage {
  items: readonly OwnSearchItem[]
  page: number
  limit: number
  hasMore: boolean
}

const text = (value: unknown): string | null => (typeof value === 'string' && value.length > 0 ? value : null)

export function decodeOwnSearchPage(raw: unknown): OwnSearchPage {
  if (typeof raw !== 'object' || raw === null) throw new Error('поиск для продажи: ожидался объект')
  const value = raw as Record<string, unknown>
  if (!Array.isArray(value.items)) throw new Error('поиск для продажи: нет списка items')
  return {
    items: value.items.map((item): OwnSearchItem => {
      if (typeof item !== 'object' || item === null) throw new Error('поиск для продажи: строка не объект')
      const row = item as Record<string, unknown>
      const productId = text(row.productId)
      const name = text(row.name)
      if (productId === null || name === null) throw new Error('поиск для продажи: у строки нет productId или name')
      return { productId, name, sku: text(row.sku), matchedBarcode: text(row.matchedBarcode), inCash: row.inCash === true, cardKey: text(row.cardKey) }
    }),
    page: typeof value.page === 'number' ? value.page : 1,
    limit: typeof value.limit === 'number' ? value.limit : 0,
    hasMore: value.hasMore === true,
  }
}